export const conditionalCheck = <Value, Values, Error>(predicate: (value: Value, values: Values) => boolean, check: (value: Value, values: Values) => Error) =>
  (value: Value, values: Values) => predicate(value, values) ? check(value, values) : null

export const memoize = <A>(fn: () => A) => {
  let saved: A

  return () => saved || (saved = fn(), saved)
}
